import * as React from 'react';
import { Menu } from 'antd';
import { default as styled } from 'styled-components';
import { blueColor, blueOpacityColor, middleBlackColor, weightBlackColor, whiteColor } from '@config/index';

export const NiMenu: typeof Menu = styled(Menu)`
  &.ant-menu {
    width: 200px;
    border: 0;

    &.ant-menu-horizontal {
    }

    .ant-menu-inline .ant-menu-item,
    .ant-menu-inline .ant-menu-submenu-title {
      width: 100% !important;
    }

    &:not(.ant-menu-horizontal) .ant-menu-item-selected {
      background-color: ${blueColor};
    }
  }
` as any;

(NiMenu as any).Item = styled(Menu.Item)`
  &.ant-menu-item {
    box-sizing: border-box;
    max-width: 200px;
    font-size: 14px;
    color: ${middleBlackColor};

    a {
      color: ${weightBlackColor};
    }

    &.ant-menu-item-selected {
      // border: ${blueColor} 1px solid;
      background: ${whiteColor} !important;

      a {
        color: ${blueColor};
        font-weight: normal;
      }

      &::after {
        border-right: none;
      }
    }

    &.bold {
      align-items: center;
      padding-left: 26px !important;
      font-weight: normal;

      a {
        display: flex;
        align-items: center;
      }

      i:not(.iconfont) {
        font-size:18px;
        margin-right:19px;
        margin-left:3px;
      }

      .iconfont {
        margin-right: 16px;
        font-size: 24px;
        font-weight: normal;
      }
    }
  }
`;
NiMenu.Divider = styled(Menu.Divider)`
  &.ant-menu-item-divider {
    margin: 8px 0 !important;
  }
`;
(NiMenu as any).ItemGroup = styled(Menu.ItemGroup)`
  &.ant-menu-item-group {
    .ant-menu-item-group-title {
      padding-left: 48px;
      width: 200px;
      height: 48px;
      font-size: 14px;
      font-weight: normal;
      align-items: center;
      display: flex;
      color: ${weightBlackColor};

      span {
        align-items: center;
        display: flex;
      }
      a {
        display: flex;
        align-items: center;
      }

      i {
        margin-right: 16px;
        font-size: 24px;
        font-weight: normal;
      }
    }
  }
`;
(NiMenu as any).SubMenu = styled(Menu.SubMenu)``;
